import { useContext, useState } from 'react';
import { SmartContext } from '../Core/SmartContext';
import { getControlValueFromState, handleControlValueChange } from '../Core/SmartFunctions';
import { SimpleFormControlArguments, State } from '../Core/SmartTypes';
// import qrCode from '../../styles/images/qr.jpg';
import { axiosClient } from '../Service/axiosClient';
import Swal from 'sweetalert2';

const FileUploader = (args: SimpleFormControlArguments) => {
    const { state, dispatch } = useContext(SmartContext);
    const { control, dataKey, parentDataKey } = { ...args };
    const customProperties = control.props.customProperties;

    const MAX_FILE_SIZE = customProperties?.maxFileSize || 15 * 1024 * 1024;

    const data = getControlValueFromState(dataKey, state as State);

    const [image, setImage] = useState(data);

    const handleImageUpload = async (e: any) => {
        let link = '';
        if (e.target.files != null && e.target.files.length > 0) {

            const apiUrl = `${process.env.REACT_APP_COMMON_API}/upload/profile`;
            const formData = new FormData();
            formData.append('image', e.target.files[0]);
            // const response = await axiosClient().post(apiUrl, formData);
            // link = response.data.link;
            // setImage(link);
            // handleControlValueChange({ control, value: link, dataKey, parentDataKey, state, dispatch });
            const file = e.target.files[0];
            
            if (file.size > MAX_FILE_SIZE) {
                Swal.fire({
                    title: "Large file..!",
                    text: `Please upload a file with size less than ${MAX_FILE_SIZE / (1024 * 1024)} MB`,
                    icon: "warning"
                  });
                return;
            }

            if (file.type.startsWith('image/')) {
                const apiUrl = `${process.env.REACT_APP_COMMON_API}/upload/profile`;
                const formData = new FormData();
                formData.append('image', file);
                
                try {
                    const response = await axiosClient().post(apiUrl, formData);
                    if (!response?.data?.success || !response?.data?.link) {
                        throw new Error(response?.data?.message || 'Image upload failed');
                    }
                    link = response.data.link;
                    setImage(link);
                    handleControlValueChange({ control, value: link, dataKey, parentDataKey, state, dispatch });
                } catch (error: any) {
                    Swal.fire({
                        title: 'Upload failed',
                        text: error?.response?.data?.message || error?.message || 'Could not upload profile picture',
                        icon: 'error',
                    });
                }
            } else {
                alert("File type is not supported to Upload Profile Picture")            
            }
        }
    };
    return (
        <>
        <div className='font-16 font-500 mb-3 text-center text-sm-start'>Upload now or send to us via WhatsApp</div>
            <div className="profile_picture_qr_display">
                

                <div className="profile_picture_section">
                    <label className="profile_picture_edit" htmlFor="choose_image">
                        <img alt="" src={image || 'https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/user-img-h5.svg'} className={image ? 'w-100' : 'img-fluid opacity-50'} />
                        <label className="image-edit cursor-pointer" htmlFor="choose_image"></label>
                    </label>
                 
                    <input
                            type="file"
                            className="d-none"
                            id="choose_image"
                            onChange={handleImageUpload}
                            accept="image/*"
                            style={{ opacity: '0.1' }}
                        />
                   
                </div>
                <div className="or">
                    <span>or</span>
                </div>

          

                <div className="qr_section">
                    <div className="qr">
                        <img src='https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/whatsapp_qr.png' width={120} alt=""/>
                    </div>

                    <div className="whatapp_text bg-green rounded-end px-4">
                        <p className="font-400 mb-0">Scan and send it to us on</p>
                        <div className="d-flex justify-content-center align-items-center">
                            <b className="bi bi-whatsapp fs-5 me-2"></b>
                            <span>WhatsApp</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FileUploader;
